export class ItemAssetMap {
  id: string;
  assetId: string;
}
